import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import ContactForm from './components/ContactForm';
import Location from './components/Location';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

const App: React.FC = () => {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <ContactForm />
      <Location />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default App;
